import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { selectPayout } from '../../../../store/payout-agreement/payout-agreement.reducers'
import { combineLatest, filter, firstValueFrom, take, tap } from 'rxjs'
import { splitUnderscoreAndCapitalize } from '../../../../utils/payout-agreement.utils'
import { CommonModule, NgIf, UpperCasePipe } from '@angular/common'
import {
  PayoutAgreement,
  PayoutFrequency
} from '../../../../store/payout-agreement/payout-agreement.state'
import { User } from '../../../../store/auth/auth.state'
import {
  ExtendedSalaryComponent,
  StatutoryCompliances
} from '../../../../store/employee-salary/employee-salary.state'
import { selectSelectedUser } from '../../../../store/user/user.reducer'
import {
  selectBasis,
  selectCtc,
  selectOtherComponents,
  selectPayoutData,
  selectStatutoryCompliances
} from '../../../../store/payout-agreement/payout-agreement.selectors'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'app-payout-agreement-summary',
  imports: [NgIf, FormsModule, ReactiveFormsModule, CommonModule, UpperCasePipe, CapitalizePipe],
  templateUrl: './payout-agreement-summary.component.html',
  styleUrl: './payout-agreement-summary.component.scss'
})
export class PayoutAgreementSummaryComponent implements OnInit {
  store = inject(Store)
  formatEnumValues = splitUnderscoreAndCapitalize
  @Output() screenNumber = new EventEmitter<number>()
  payoutFrequency: PayoutFrequency | null = null
  ctc: number | null = null
  currency: string | null = null
  basis: string | null = null
  payout: PayoutAgreement | null = null

  otherComponents!: ExtendedSalaryComponent[]
  compliancesList!: StatutoryCompliances | null
  payoutData!: [string, number][]
  user!: User
  async ngOnInit() {
    this.user = await firstValueFrom(
      this.store.pipe(
        select(selectSelectedUser),
        filter((user): user is User => !!user),
        take(1)
      )
    )
    combineLatest([
      this.store.select(selectStatutoryCompliances),
      this.store.select(selectCtc),
      this.store.select(selectOtherComponents),
      this.store.select(selectPayoutData)
    ])
      .pipe(
        take(1),
        tap(([compliancesList, ctc, otherComponents, payoutData]) => {
          this.compliancesList = compliancesList ?? null
          this.ctc = ctc ?? 0
          this.otherComponents = otherComponents ?? []
          this.payoutData = (Object.entries(payoutData ?? {}) ?? [])
            .filter(([key, value]) => {
              if (key === 'pf' && value === 0) return false
              // if (this.user.role === 'Contractor' && key === 'hra') return false
              if (
                this.user?.userRoles?.some(ur => ur.role?.name === 'Contractor') &&
                key === 'hra'
              ) {
                return false
              }

              return true
            })
            .map(([key, value]) => {
              if (['pf', 'hra'].includes(key)) {
                key = key.toUpperCase()
              } else if (key === 'specialAllowance') {
                key = 'Special Allowance'
              }
              return [key, value]
            })
        })
      )
      .subscribe()
    this.payout = await firstValueFrom(this.store.select(selectPayout))
    this.basis = await firstValueFrom(this.store.select(selectBasis))
  }

  //Helper method to check if the employee has any salary compliances
  hasValidCompliances() {
    return (
      this.compliancesList &&
      (Object.keys(this.compliancesList) as (keyof StatutoryCompliances)[]).some(
        key => key !== 'employerCapping' && this.compliancesList?.[key] === true
      )
    )
  }

  goToScreen() {
    this.screenNumber.emit(0) //Compliance Screen is 0
  }
}
